// extracted by mini-css-extract-plugin
export var avatarContainer = "_3m-0";
export var gray = "_3m-f";
export var green = "_3m-c";
export var icon = "_3m-9";
export var image = "_3m-1";
export var lg = "_3m-6";
export var md = "_3m-5";
export var presenceDot = "_3m-b";
export var red = "_3m-d";
export var sm = "_3m-4";
export var status = "_3m-a";
export var xl = "_3m-7";
export var xs = "_3m-3";
export var xxl = "_3m-8";
export var xxs = "_3m-2";
export var yellow = "_3m-e";